"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _lodash = require("lodash");
function useSyncElementDimension(_ref) {
  var dimension = _ref.dimension,
    sourceEl = _ref.sourceEl,
    targetEl = _ref.targetEl,
    _ref$strategy = _ref.strategy,
    strategy = _ref$strategy === void 0 ? 'source-to-target' : _ref$strategy;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    internalSourceEl = _useState2[0],
    setInternalSourceEl = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    internalTargetEl = _useState4[0],
    setInternalTargetEl = _useState4[1];
  var _sourceEl = sourceEl || internalSourceEl;
  var _targetEl = targetEl || internalTargetEl;
  (0, _react.useEffect)(function () {
    if (!_sourceEl || !_targetEl) {
      return;
    }
    var capitalized = (0, _lodash.capitalize)(dimension);
    var min = "min".concat(capitalized);
    var max = "max".concat(capitalized);
    var isMaxStrategy = strategy === 'max';
    function syncDimension() {
      // reset styles so that the elements return to their natural size before syncing
      _sourceEl.style[min] = _sourceEl.style[max] = _targetEl.style[min] = _targetEl.style[max] = null;
      var sourceValue = getComputedStyle(_sourceEl)[dimension];
      var elementToModify;
      var referenceValue;
      if (strategy === 'source-to-target') {
        elementToModify = _targetEl;
        referenceValue = sourceValue;
      } else if (isMaxStrategy) {
        var targetValue = getComputedStyle(_targetEl)[dimension];
        if (parseFloat(sourceValue) >= parseFloat(targetValue)) {
          elementToModify = _targetEl;
          referenceValue = sourceValue;
        } else {
          elementToModify = _sourceEl;
          referenceValue = targetValue;
        }
      }
      elementToModify.style[min] = elementToModify.style[max] = referenceValue;
    }
    syncDimension();
    var resizeObserver = new ResizeObserver(syncDimension);
    resizeObserver.observe(_sourceEl);
    var mutationObserver;
    if (isMaxStrategy) {
      resizeObserver.observe(_targetEl);
      mutationObserver = new MutationObserver(syncDimension);
      var mutationObserverOptions = {
        subtree: true,
        childList: true,
        characterData: true
      };
      mutationObserver.observe(_sourceEl, mutationObserverOptions);
      mutationObserver.observe(_targetEl, mutationObserverOptions);
    }
    return function () {
      var _mutationObserver;
      resizeObserver.disconnect();
      (_mutationObserver = mutationObserver) === null || _mutationObserver === void 0 || _mutationObserver.disconnect();
    };
  }, [_sourceEl, _targetEl, dimension, strategy]);
  return {
    sourceEl: _sourceEl,
    targetEl: _targetEl,
    setTargetEl: setInternalTargetEl,
    setSourceEl: setInternalSourceEl
  };
}
var _default = exports["default"] = useSyncElementDimension;
//# sourceMappingURL=useSyncElementDimension.js.map